module.exports = __webpack_public_path__ + "static/img/3.44beee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/3.png
// module id = n2X9
// module chunks = 0